import React, { useState } from 'react';
import LocalizedStrings from 'react-localization';

function SeoBlock({ locale }) {
  const strings = new LocalizedStrings({
    ru: {
      title1: 'Страховка КАСКО — все, что необходимо знать',
      description1_1: 'Страхование КАСКО — это надежная защита автомобиля от любых инцидентов, которые возможны на дороге или стоянке.',
      description1_2: 'Страховка КАСКО — это страхование транспортного средства на случай пожара, стихийных бедствий, падения на машину деревьев и других предметов, угона или кражи из автомобиля.',
      description1_3: 'Воспользовавшись консультацией или лично сравнив все условия, вы подберете нужный пакет, который оправдает ожидания и получите защиту авто на выгодных условиях.',
      description1_4: 'Оформить КАСКО на автомобиль можно сроком от месяца до года.',
      description1_5: 'Для этого необходимо подготовить авто к осмотру, а также иметь при себе:',
      description1_6: 'паспорт и ИНН код;',
      description1_7: 'техпаспорт на ТС;',
      description1_8: 'водительское удостоверение.',
      description1_9: 'Добровольное автострахование КАСКО не занимает много времени. Агентам достаточно сфотографировать транспортное средство, заполнить акт осмотра и договор страховки.',
      title2: 'Что покрывает страховка Полное КАСКО',
      description2_1: 'Стоимость полного КАСКО выше стандартного пакета, но вы получаете страховое покрытие таких рисков:',
      description2_2_1: 'ДТП.',
      description2_2_2: 'Возмещаются убытки при повреждении или уничтожении транспорта вследствие наезда и столкновения. Также возмещаются расходы при битье стекла из-за выбрасывания камней или других предметов из-под колес другого автомобиля;',
      description2_3_1: 'угон.',
      description2_3_2: 'Клиент получает возмещение средств, если машину угнали без его ведома или в результате захвата;',
      description2_4_1: 'ПДТЛ',
      description2_4_2: '(противоправные действия третьих лиц). Если авто было уничтожено или повреждены его части, дополнительное оборудование, покрытие, стекла, а также при похищении единичных частей;',
      description2_5_1: 'стихийное бедствие.',
      description2_5_2: 'В него входит повреждение или уничтожение автомобиля от воздействия природных явлений (дождя, града, сильного снегопада, схода лавины, наводнения, бури, шторма, урагана, удара молнии, землетрясения, проседания грунта, смерча и т.д), нападения животных, падения предметов, взрыва или самовозгорания.',
      description2_6: 'Полное КАСКО на автомобиль — это 100% возмещение убытков и трат на ремонт.',
      title3: 'Сколько стоит КАСКО в Украине — от чего зависит стоимость страховки',
      description3_1: 'Как формируется цена КАСКО в Украине:',
      description3_2: 'тип и цена транспортного средства;',
      description3_3: 'год выпуска;',
      description3_4: 'наличие противоугонной сигнализации;',
      description3_5: 'выбранный пакет страхования;',
      description3_6: 'размер франшизы;',
      description3_7: 'срок действия договора;',
      description3_8: 'условия оплаты.',
      description3_9: 'Узнать стоимость КАСКО можно, не выходя из дома, указав необходимую информацию в онлайн калькуляторе и рассчитать сумму страхового платежа.',
      description3_10: 'Купить КАСКО на авто можно одним платежом и в рассрочку. Для некоторых клиентов удобнее, когда платеж разбивают на 12 частей с ежемесячной оплатой.',
      description3_11: 'Также обратите внимание на оформление КАСКО онлайн. Это удобно, быстро и бережет ваши нервы!',
      title4: 'На какие транспортные средства можно оформить страховку КАСКО',
      description4_1: 'Оформить КАСКО могут физические и юридические лица.',
      description4_2: 'Для страховки допускаются следующие виды ТС:',
      description4_3: 'легковой, грузопассажирский и грузовой транспорт;',
      description4_4: 'автобусы и микроавтобусы;',
      description4_5: 'полуприцепы и прицепы;',
      description4_6: 'мотоциклы;',
      description4_7: 'специализированная и сельхозтехника.',
      description4_8: 'По запросу в договор страхования включают дополнительную технику, установленную на авто.',
      title5: 'Что такое франшиза в страховании КАСКО',
      description5_1: 'Франшиза позволяет купить полис КАСКО по меньшей цене, поскольку часть затрат на ремонт при повреждении клиент берет на себя. Эта часть и называется франшизой - сумма фиксированного размера, что указывается в договоре.',
      description5_2: 'СК разделяет риски с клиентом, поэтому может предоставить значительную скидку. При этом аккуратные водители могут избежать любого повреждения во время действия полиса, и получат страховку от более серьезных происшествий по выгодной цене.',
      description5_3: 'Чаще всего потребуется оплата, если не задокументирован виновник происшествия. В этом случае клиент выплачивает фиксированную сумму, а остальные расходы берет на себя страховая компания. Если расходы на ремонт не превышают уровня франшизы, клиент оплачивает их самостоятельно. Если автомобиль поврежден не по вашей вине, и виновник установлен, то он возмещает компенсацию за починку.',
      description5_4: 'Автострахование КАСКО с франшизой помогает экономить уже на этапе покупки полиса, ведь вы платите намного меньше. При этом, пока действует полис, вы можете благополучно избежать неприятных происшествий, и вам не придется ничего оплачивать или ремонт будет стоить гораздо меньшую сумму.',
      description5_5: 'Если вы не знаете какой вариант выбрать — обращайтесь за консультацией к нашим специалистам на сайте. Вы получите исчерпывающие ответы на вопросы и подберете подходящий вариант страховки.',
      btnOpen: 'Развернуть',
      btnClose: 'Свернуть',
    },
    ua: {
      title1: 'Страховка КАСКО — все, що необхідно знати',
      description1_1: 'Страхування КАСКО — це надійний захист автомобіля від будь-яких інцидентів, що можливі на дорозі або стоянці.',
      description1_2: 'Страховка КАСКО — це страхування транспортного засобу на випадок пожежі, стихійних лих, падіння на машину дерев та інших предметів, викрадення або крадіжки з автомобіля.',
      description1_3: 'Скориставшись консультацією або особисто порівнявши всі умови, ви підберете потрібний пакет, який виправдає очікування і отримаєте захист авто на вигідних умовах. ',
      description1_4: 'Оформити КАСКО на автомобіль можна терміном від місяця до одного року.',
      description1_5: 'Для цього необхідно підготувати авто до огляду, а також мати при собі:',
      description1_6: 'паспорт і ІПН код;',
      description1_7: 'техпаспорт на ТЗ;',
      description1_8: 'водійське посвідчення.',
      description1_9: 'Добровільне автострахування КАСКО не займає багато часу. Агентам досить сфотографувати транспортний засіб, заповнити акт огляду і договір страховки.',
      title2: 'Що покриває страховка повне КАСКО',
      description2_1: 'Вартість повного КАСКО вище стандартного пакета, але ви отримуєте страхове покриття таких ризиків:',
      description2_2_1: 'ДТП.',
      description2_2_2: 'Відшкодовуються збитки при пошкодженні або знищенні транспорту внаслідок наїзду і зіткнення. Також відшкодовуються витрати при битті скла через викидання каменів або інших предметів з-під коліс іншого автомобіля;',
      description2_3_1: 'викрадення.',
      description2_3_2: 'Клієнт отримує відшкодування коштів, якщо машину викрали без його відома або в результаті захоплення;',
      description2_4_1: 'ПДТО',
      description2_4_2: '(протиправні дії третіх осіб). Якщо авто було знищено або пошкоджено його частини, додаткове обладнання, покриття, скло, а також при викраденні окремих елементів;',
      description2_5_1: 'стихійне лихо.',
      description2_5_2: 'У нього входить пошкодження або знищення автомобіля від впливу природних явищ (дощу, граду, сильного снігопаду, сходу лавини, повені, шторму, урагану, удару блискавки, землетрусу, просідання ґрунту, смерчу тощо), нападу тварин, падіння предметів, вибуху або самозаймання.',
      description2_6: 'Повне КАСКО на автомобіль — це 100% відшкодування збитків і витрат на ремонт.',
      title3: 'Скільки коштує КАСКО в Україні — від чого залежить вартість страховки',
      description3_1: 'Як формується ціна КАСКО в Україні:',
      description3_2: 'тип і ціна транспортного засобу;',
      description3_3: 'рік випуску;',
      description3_4: 'наявність системи запобігання викраденню;',
      description3_5: 'обраний пакет страхування;',
      description3_6: 'розмір франшизи;',
      description3_7: 'термін дії договору;',
      description3_8: 'умови оплати.',
      description3_9: 'Дізнатися вартість КАСКО можна, не виходячи з дому, вказавши необхідну інформацію в онлайн калькуляторі і розрахувати суму страхового платежу.',
      description3_10: 'Купити КАСКО на авто можна одним платежем і на виплат (в розстрочення). Для деяких клієнтів зручніше, коли платіж розбивають на 12 частин з щомісячною оплатою.',
      description3_11: 'Також зверніть увагу на оформлення КАСКО онлайн. Це зручно, швидко і береже ваші нерви!',
      title4: 'На які транспортні засоби можна оформити страховку КАСКО',
      description4_1: 'Оформити КАСКО можуть фізичні та юридичні особи.',
      description4_2: 'Для страховки допускаються наступні види ТС:',
      description4_3: 'легковий, вантажо-пасажирський і вантажний транспорт;',
      description4_4: 'автобуси та мікроавтобуси;',
      description4_5: 'напівпричепи та причепи;',
      description4_6: 'мотоцикли;',
      description4_7: 'спеціалізована та сільгосптехніка.',
      description4_8: 'За запитом в договір страхування включають додаткову техніку, встановлену на авто.',
      title5: 'Що таке франшиза в страхуванні КАСКО',
      description5_1: 'Франшиза дозволяє купити поліс КАСКО за меншою ціною, оскільки частину витрат на ремонт при пошкодженні клієнт бере на себе. Ця частина і називається франшизою — сума фіксованого розміру, що вказується в договорі.',
      description5_2: 'СК розділяє ризики з клієнтом, тому може надати значну знижку. При цьому обережні водії можуть уникнути будь-якого пошкодження під час дії поліса, і отримають страховку від більш серйозних подій за вигідною ціною.',
      description5_3: 'Найчастіше потрібна оплата, якщо не задокументовано винуватця події. У цьому випадку клієнт виплачує фіксовану суму, а решту витрат бере на себе страхова компанія. Якщо витрати на ремонт не перевищують рівня франшизи, клієнт оплачує їх самостійно. Якщо автомобіль пошкоджений не з вашої вини, і винуватець встановлений, то він відшкодовує компенсацію за ремонт.',
      description5_4: 'Автострахування КАСКО з франшизою допомагає економити вже на етапі покупки полісу, адже ви платите набагато менше. При цьому, поки діє поліс, ви можете щасливо уникнути неприємних пригод, і вам не доведеться нічого сплачувати або ремонт буде коштувати набагато меншу суму.',
      description5_5: 'Якщо ви не знаєте який варіант обрати — звертайтеся за консультацією до наших фахівців на сайті. Ви отримаєте вичерпні відповіді на питання і підберете слушний варіант страховки.',
      btnOpen: 'Розгорнути',
      btnClose: 'Згорнути',
    },
  });
  strings.setLanguage(locale);
  const [isOpen, setIsOpen] = useState(false);

  return (
    <section className="seo-block">
      <div className="container">
        <div className="seo-block-inner">
          <div className={isOpen ? "seo-block-text open" : "seo-block-text"}>
            {/* block */}
            <h2 className="seo-block-title">{strings.title1}</h2>
            <p className="seo-block-description">{strings.description1_1}</p>
            <p className="seo-block-description">{strings.description1_2}</p>
            <p className="seo-block-description">{strings.description1_3}</p>
            <p className="seo-block-description">{strings.description1_4}</p>
            <p className="seo-block-description seo-block-underline">{strings.description1_5}</p>
            <ul className="seo-block-list">
              <li>
                <p className="seo-block-description">{strings.description1_6}</p>
              </li>
              <li>
                <p className="seo-block-description">{strings.description1_7}</p>
              </li>
              <li>
                <p className="seo-block-description">{strings.description1_8}</p>
              </li>
            </ul>
            <p className="seo-block-description">{strings.description1_9}</p>
            {/* End block */}

            {/* block */}
            <h2 className="seo-block-title">{strings.title2}</h2>
            <p className="seo-block-description seo-block-underline">{strings.description2_1}</p>
            <ul className="seo-block-list">
              <li>
                <p className="seo-block-description">
                  <strong>{strings.description2_2_1}</strong>
                  {strings.description2_2_2}
                </p>
              </li>
              <li>
                <p className="seo-block-description">
                  <strong>{strings.description2_3_1}</strong>
                  {strings.description2_3_2}
                </p>
              </li>
              <li>
                <p className="seo-block-description">
                  <strong>{strings.description2_4_1}</strong>
                  {strings.description2_4_2}
                </p>
              </li>
              <li>
                <p className="seo-block-description">
                  <strong>{strings.description2_5_1}</strong>
                  {strings.description2_5_2}
                </p>
              </li>
            </ul>
            <p className="seo-block-description">{strings.description2_6}</p>
            {/* End block */}

            {/* block */}
            <h2 className="seo-block-title">{strings.title3}</h2>
            <p className="seo-block-description seo-block-underline">{strings.description3_1}</p>
            <ul className="seo-block-list">
              <li>
                <p className="seo-block-description">{strings.description3_2}</p>
              </li>
              <li>
                <p className="seo-block-description">{strings.description3_3}</p>
              </li>
              <li>
                <p className="seo-block-description">{strings.description3_4}</p>
              </li>
              <li>
                <p className="seo-block-description">{strings.description3_5}</p>
              </li>
              <li>
                <p className="seo-block-description">{strings.description3_6}</p>
              </li>
              <li>
                <p className="seo-block-description">{strings.description3_7}</p>
              </li>
              <li>
                <p className="seo-block-description">{strings.description3_8}</p>
              </li>
            </ul>
            <p className="seo-block-description">{strings.description3_9}</p>
            <p className="seo-block-description">{strings.description3_10}</p>
            <p className="seo-block-description">{strings.description3_11}</p>
            {/* End block */}

            {/* block */}
            <h2 className="seo-block-title">{strings.title4}</h2>
            <p className="seo-block-description">{strings.description4_1}</p>
            <p className="seo-block-description seo-block-underline">{strings.description4_2}</p>
            <ul className="seo-block-list">
              <li>
                <p className="seo-block-description">{strings.description4_3}</p>
              </li>
              <li>
                <p className="seo-block-description">{strings.description4_4}</p>
              </li>
              <li>
                <p className="seo-block-description">{strings.description4_5}</p>
              </li>
              <li>
                <p className="seo-block-description">{strings.description4_6}</p>
              </li>
              <li>
                <p className="seo-block-description">{strings.description4_7}</p>
              </li>
            </ul>
            <p className="seo-block-description">{strings.description4_8}</p>
            {/* End block */}

            {/* block */}
            <h2 className="seo-block-title">{strings.title5}</h2>
            <p className="seo-block-description">{strings.description5_1}</p>
            <p className="seo-block-description">{strings.description5_2}</p>
            <p className="seo-block-description">{strings.description5_3}</p>
            <p className="seo-block-description">{strings.description5_4}</p>
            <p className="seo-block-description">{strings.description5_5}</p>
            {/* End block */}
          </div>

          <button
            className="seo-block-btn"
            type="button"
            onClick={() => setIsOpen(!isOpen)}
          >
            {isOpen ? `${strings.btnClose}` : `${strings.btnOpen}`}
          </button>
        </div>
      </div>
    </section>
  );
}

export default SeoBlock;
